import { Component, Input } from '@angular/core';

@Component({
	selector: 'summary',
	template: '<div>@if (label) {<div class="label">{{label}}</div>}<div class="content"><ng-content></ng-content></div></div>',
	styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {

	private _label?: string;
	@Input() set label(value: string | undefined) {
		this._label = value;
	}
	get label() {
		return this._label;
	}

	constructor() { }

}
